import { useState } from "react";
import { getItemPopupList } from "src/apis/itemApi";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import {
	defaultKSK2040_R01Filter,
	useKSK2040_R01Store,
} from "./Store_KSK2040_R01";

export const SearchSection_KSK2040_R01 = () => {
	const { KSK2040_R01Filter, setKSK2040_R01Filter } = useKSK2040_R01Store();
	const { compCdList, workPlaceList } = useCommonCodeStore();
	const { setCodeSearchModalProps } = useUiuxStore();
	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });
	const itemFocusId = "KSK2040_R01-itemCd-search";
	const employeeFocusId = "KSK2040_R01-productEmp-search";
	const codeModalWrapperOption = {
		wrapperStyle: "w-[700px] min-w-[700px] mr-[10px]",
		titleStyle: "w-[50px] min-w-[50px] text-left",
		codeInputStyle: "w-[190px] min-w-[190px]",
		nameTagStyle: "w-[300px] min-w-[300px] text-left",
	};

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: "itemCd",
			category: "품목",
			focusId: itemFocusId,
			responseMapping: { itemCd: "itemCd", itemNm: "itemNm" },
			searchFunction: async (searchText: string) => {
				const response = await getItemPopupList(searchText, "", "", "");
				return response.data.data.find((item) => item.itemCd === searchText);
			},
			extraFilter: () => ({
				itemCd: KSK2040_R01Filter.itemCd,
				itemNm: KSK2040_R01Filter.itemNm,
			}),
		},
		{
			fieldName: "productEmp",
			category: "작업자",
			focusId: employeeFocusId,
			responseMapping: { empNo: "productEmp", empNm: "productEmpNm" },
			extraFilter: () => ({
				productEmp: KSK2040_R01Filter.productEmp,
				productEmpNm: KSK2040_R01Filter.productEmpNm,
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: KSK2040_R01Filter,
		setEditData: setKSK2040_R01Filter,
		defaultData: defaultKSK2040_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: "KSK2040_R01-search",
	});

	return (
		<SearchSectionDoubleForm>
			<SearchDropDownForm
				label="사업장"
				value={KSK2040_R01Filter.compCd}
				optionList={compCdList}
				onChangeItem={(item) => setKSK2040_R01Filter({
					compCd: item?.compCd || "",
				})}
			/>
			<SearchDateRangeForm
				label="생산기간"
				visible={pickerVisible}
				setVisible={setPickerVisible}
				dateRange={KSK2040_R01Filter.dateRange}
				setDateRange={(dateRange) => setKSK2040_R01Filter({ dateRange })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>
			<SearchDropDownForm
				label="작업공정"
				value={KSK2040_R01Filter.workplaceCd}
				optionList={workPlaceList.filter((item) =>
					item.compCd === KSK2040_R01Filter.compCd)}
				onChangeItem={(item) => setKSK2040_R01Filter({
					workplaceCd: item?.workplaceCd || "",
				})}
				editable={KSK2040_R01Filter.compCd !== ""}
			/>
			<SearchCodeModalForm
				label="품목"
				value={KSK2040_R01Filter.itemCd}
				valueLabel={KSK2040_R01Filter.itemNm}
				handleFoucsId={itemFocusId}
				onChange={getFieldHandlers("itemCd").onChange}
				onDoubleClick={getFieldHandlers("itemCd").onDoubleClick}
				onKeyDown={getFieldHandlers("itemCd").onEnterKeyDown}
				wrapperOption={codeModalWrapperOption}
			/>
			<SearchCodeModalForm
				label="작업자"
				value={KSK2040_R01Filter.productEmp}
				valueLabel={KSK2040_R01Filter.productEmpNm}
				handleFoucsId={employeeFocusId}
				onChange={getFieldHandlers("productEmp").onChange}
				onDoubleClick={getFieldHandlers("productEmp").onDoubleClick}
				onKeyDown={getFieldHandlers("productEmp").onEnterKeyDown}
				wrapperOption={codeModalWrapperOption}
			/>
		</SearchSectionDoubleForm>
	);
};
